/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not save the schedule or event." |
*
* @param {Agent_Triggers_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_save_error = /** @type {((inputs?: Agent_Triggers_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auslöser konnte nicht gespeichert werden.")
	return /** @type {LocalizedString} */ ("Could not save the schedule or event.")
});